export const PATHS = {
  ROOT: '/',
  SIGN_UP_COMPLETE: '/?modal=welcome',
  EMAIL_REGISTERED: '/?modal=email-registered',
  CHANNELS: '/channels',
  FOLLOWING: '/following',
  NOTIFICATIONS_ME: '/notifications/me',
  NOTIFICATIONS_ME_DETAIL: '/notifications/me/[my_notification_id]',
  NOTIFICATIONS_NEWS: '/notifications/news',
  NOTIFICATIONS_NEWS_DETAIL: '/notifications/news/[news_id]',
  SETTINGS: '/settings',
  SETTINGS_DELETE_ACCOUNT: '/settings/delete-account',
  SETTINGS_PAYMENT_HISTORY: '/settings/payment-history',
  SETTINGS_PAYMENT_HISTORY_DETAIL: '/settings/payment-history/[history_id]',
  SETTINGS_PAYMENT_METHODS: '/settings/payment-methods',
  SETTINGS_PROFILE: '/settings/profile',
  SETTINGS_NOTIFICATIONS: '/settings/notifications',
  SETTINGS_LANGUAGE: '/settings/language',
  LIVENODE_ID_ORIGIN: process.env.NEXT_PUBLIC_LIVENODE_ID_ORIGIN,
  LIVENODE_ID_ABOUT:
    'https://help.livenode.jp/hc/ja/articles/56378063854617-LIVENODE-ID%E3%81%A8%E3%81%AF',
  ABOUT: '/about',
  ABOUT_FOR_ARTISTS: 'https://klew-for-artist.studio.site',
  ARTISTS_BASE: '/artists',
  ARTISTS: '/artists/[artist_slug]',
  ARTISTS_BADGES: '/artists/[artist_slug]/badges',
  ARTISTS_PAST_EVENTS: '/artists/[artist_slug]/past-events',
  ARTISTS_CHANNELS: '/artists/[artist_slug]/channels/[channel_id]',
  ARTISTS_CHANNELS_POSTS: '/artists/[artist_slug]/channels/[channel_id]/posts/[post_id]',
  SUPER_MESSAGE_COMPLETE: '/artists/[artist_slug]/channels/[channel_id]/complete',
  SUPER_MESSAGE_ABOUT: 'https://note.com/kulture/n/nb557628a5c33?sub_rt=share_pb',
  SIGN_UP: '/sign-up',
  SIGN_UP_PROFILE: '/sign-up/profile',
  EVENTS_BASE: '/events',
  EVENTS: '/events/[event_id]',
  EVENTS_PERFORMANCES_BASE: '/events/performances',
  EVENTS_PERFORMANCES: '/events/performances/[performance_id]',
  EVENTS_PERFORMANCES_UPLOAD: '/events/performances/[performance_id]/ticket-upload',
  EVENTS_PERFORMANCES_CHANNELS: '/events/performances/[performance_id]/channels',
  EVENTS_SALE_SCHEDULES_BASE: '/events/sale-schedules',
  EVENTS_SALE_SCHEDULES: '/events/sale-schedules/[saleschedule_id]',
  EVENTS_SALE_SCHEDULES_COMPLETE: '/events/sale-schedules/[saleschedule_id]/complete',
  TICKETS: '/tickets/items',
  TICKETS_DETAIL: '/tickets/items/[ticket_application_id]',
  TICKETS_USED: '/tickets/items/used',
  TICKETS_LOTTERY: '/tickets/lottery',
  TICKETS_LOTTERY_DETAILS: '/tickets/lottery/[ticket_application_id]',
  VERIFY_EMAIL: '/verify-email',
  CONTACT: 'https://help.klew.jp/hc/requests/new',
  FAQ: 'https://help.klew.jp/hc/categories/35734581091353',
  TERMS: 'https://help.klew.jp/hc/articles/35825750966681',
  PRIVACY_POLICY: 'https://kulture.jp/privacy.html',
  LEGAL: 'https://help.klew.jp/hc/articles/35861323648025',
  GUIDE_LINE: 'https://help.klew.jp/hc/articles/36709582155161',
  HELP: 'https://help.klew.jp/hc/articles/37523245220121',
  EXPORT_PRIVATE_KEY_HELP: 'https://help.klew.jp/hc/articles/59992939736601',
  UPLOAD_REQUEST: 'https://help.klew.jp/hc/articles/36709943798681',
  X: 'https://x.com/klew_info',
  INSTAGRAM: 'https://www.instagram.com/klew.info/',
  RECRUIT: 'https://note.com/kulture/n/na2d0af88493e',
  TICKET_HELP:
    'https://help.klew.jp/hc/ja/articles/36709957672345-%E3%83%81%E3%82%B1%E3%83%83%E3%83%88%E7%94%BB%E5%83%8F%E3%82%92%E3%82%A2%E3%83%83%E3%83%97%E3%83%AD%E3%83%BC%E3%83%89%E3%81%97%E3%81%A6%E3%82%82-%E7%99%BB%E9%8C%B2%E3%83%AA%E3%82%AF%E3%82%A8%E3%82%B9%E3%83%88%E3%82%A8%E3%83%A9%E3%83%BC-%E3%81%A8%E3%81%AA%E3%82%8A%E7%99%BB%E9%8C%B2%E3%81%8C%E3%81%A7%E3%81%8D%E3%81%BE%E3%81%9B%E3%82%93',
  CAREERS: 'https://note.com/kulture/n/na2d0af88493e',
} as const;

export const QUERIES = {
  WELCOME_MODAL: {
    key: 'modal',
    value: 'welcome',
  },
  FROM_ARTIST: {
    key: 'from',
    value: 'artist',
  },
  FROM_TICKET: {
    key: 'from',
    value: 'ticket',
  },
  FROM_RECEIVE_TICKET: {
    key: 'from',
    value: 'receive_ticket',
  },
  FROM_AUTH_ERROR: {
    key: 'from',
    value: 'auth_error',
  },
};

type PathsType = typeof PATHS;
type PathKeys = keyof typeof PATHS;
export type PathValues = (typeof PATHS)[PathKeys];
type AdditionalPaths = Pick<PathsType, 'NOTIFICATIONS_NEWS' | 'NOTIFICATIONS_NEWS_DETAIL'>;
export type AdditionalPathsType = AdditionalPaths[keyof AdditionalPaths][];
